import script from "./QuestionListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionListComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionListComponent.vue?vue&type=style&index=0&id=1b834000&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b834000"]])

export default __exports__